var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocalIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 9,
    viewBox: "0 0 7 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0996094 3.31086C0.0996094 1.54309 1.5379 0.104797 3.3059 0.104797C5.07345 0.104797 6.51219 1.54331 6.51219 3.31109C6.51219 5.70317 3.65619 8.4008 3.53473 8.51443C3.47053 8.5746 3.38821 8.6048 3.3059 8.6048C3.22671 8.6048 3.14753 8.57684 3.08378 8.52092C2.96187 8.4131 0.0996094 5.85617 0.0996094 3.31086ZM1.77724 3.31131C1.77724 4.15505 2.46149 4.83974 3.3059 4.83974C4.14986 4.83974 4.83411 4.15527 4.83411 3.31131C4.83411 2.46735 4.14986 1.78288 3.3059 1.78288C2.46149 1.78288 1.77724 2.46757 1.77724 3.31131Z",
    fill: "#7181A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalIcon);
export default __webpack_public_path__ + "static/media/localIcon.8ec9d1dc7b8864014febf42fb590e0bb.svg";
export { ForwardRef as ReactComponent };